import { Avatar, Box, Button, Grid2, MenuItem, Modal, Select, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import TokenError from "../tokenError";
import config from '../../config/config.js';
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from 'dayjs';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import prevIcon from '../../assets/icons/left-arrow.svg'
import nextIcon from '../../assets/icons/right-arrow.svg';
import greenTick from '../../assets/icons/greenTic.svg';
import redCross from '../../assets/icons/redCross.svg';
import pickupMarker from '../../assets/icons/PickupIcon.svg';
import dropMarker from '../../assets/icons/DropIcon.svg';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import routeMarker from '../../assets/images/routeMarker.svg';
import constants from '../../constant.js';
import { useGoogleMapsLoader } from "../../utils/GoogleMapsLoader";
import { DirectionsRenderer, GoogleMap, InfoWindow, Marker, Polyline, useJsApiLoader } from "@react-google-maps/api";

const LIBRARIES = ["maps", "drawing", "places", "geometry"];

const ShuttleBooking = () => {
    const [tokenExpired, setTokenExpired] = useState(false);
    const token = localStorage.getItem('token');
    const [errorMessage, setErrorMessage] = useState('');
    const [bookingData, setBookingData] = useState([]);
    const [filteredRows, setFilteredRows] = useState([]);
    // const [dateFilter, setDateFilter] = useState(dayjs());
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [paginatedData, setPaginatedData] = useState([]);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [openRouteModal, setOpenRouteModal] = useState(false);
    const [routeData, setRouteData] = useState([]);
    const [bookingId, setBookingId] = useState('');
    const [polylineVisible, setPolylineVisible] = useState(false); 
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const clientdataShown = localStorage.getItem('hideuserinfo');


    // const loaderOptions = {
    //     id: 'google-map-script',
    //     googleMapsApiKey: constants.API_KEY, // Replace with your actual API key
    //     libraries: LIBRARIES,
    // }
    const { isLoaded, loadError } = useGoogleMapsLoader();
    const [map, setMap] = useState(null)
    const containerStyle = {
        width: '100%',
        height: '500px',
        };
    // const center = {
    //     lat: 28.644800, lng: 77.216721
    // };
    const center = {
        lat: routeData && routeData.length > 0
            ? routeData.reduce((sum, point) => sum + parseFloat(point.latitude || 0), 0) / routeData.length
            : 0,
        lng: routeData && routeData.length > 0
            ? routeData.reduce((sum, point) => sum + parseFloat(point.longitude || 0), 0) / routeData.length
            : 0,
    };
    
    const onLoad = React.useCallback((map) => {
        console.log('Map loaded successfully');
        setMap(map); // Store the map instance
    }, []);
    
    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, []);
    
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 600,
        bgcolor: 'background.paper',
        border: '1px solid #000',
        boxShadow: 24,
        p: 4,
        borderRadius:'8px'
    };

    const rowData = location.state?.rowData; // Access rowData from location state
    const dayFilter = location.state?.dayFilter;

    if (rowData){
        var tripId2 = rowData.trip_id;
    }

    const fetchBookingData = async() => {
        try {
            const url = serverUrl + '/shuttle/fetch_trip_booking_details';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                trip_id: tripId2,
                timestamp: timestamp,
                day: dayFilter
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                // setBookingData(response.data);
                const bookingData = response.data;
                setBookingData(bookingData);
                setFilteredRows(bookingData);

                // const formattedData = formatDataForCSV(customersData);
                // setAllData(formattedData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }
    useEffect(()=> {
        fetchBookingData();
    },[]);

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...filteredRows].sort((a, b) => {
        if (a[property] < b[property]) return isAscending ? -1 : 1;
        if (a[property] > b[property]) return isAscending ? 1 : -1;
        return 0;
        });
        // setRows(sortedRows);
        setFilteredRows(sortedRows);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
        const paginated = Array.isArray(filteredRows)
            ? filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : [];
        setPaginatedData(paginated);
    }, [filteredRows, page, rowsPerPage]);

    // useEffect(() => {

    //     let tripDate = dayjs(dateFilter).toISOString().split('T')[0];

    //     if(dateFilter){
    //         const filteredDateData = bookingData.filter((item) => 
    //             // item.phone_number === customerPhone
    //             (item.trip_date.split('T')[0]).includes(tripDate) || tripDate === ''
    //         );
    //         console.log('filteredDateData', filteredDateData)
    //         setFilteredRows(filteredDateData);
    //         setPage(0);
    //     }
    //     else{
    //         setFilteredRows(bookingData);
    //     }
    // },[dateFilter]);

    const fetchRouteDetailsFromBookingId = async() => {
        try {
            const url = serverUrl + '/shuttle/fetch_booking_route';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                booking_id: bookingId,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                const routeData = response.data;
                setRouteData(routeData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=> {
        console.log('booking id==', bookingId);
        if(bookingId) fetchRouteDetailsFromBookingId();
    }, [bookingId]);
    
    const viewRoute = (data) => {
        console.log('data==', data);
        setBookingId(data.booking_id); // Only set bookingId
        if(bookingId) fetchRouteDetailsFromBookingId();
    };

    useEffect(() => {
        if (routeData.length > 0) {
            setOpenRouteModal(true); // Now modal opens after data is ready
        }
    }, [routeData]);
    
    const handleClose = () => setOpenRouteModal(false);

    useEffect(() => {
        if (routeData.length > 0 && map) {
    
            const bounds = new window.google.maps.LatLngBounds();
            routeData.forEach((stop) => {
                if (stop.latitude && stop.longitude) {
                    bounds.extend(new window.google.maps.LatLng(Number(stop.latitude), Number(stop.longitude)));
                }
            });
    
            map.fitBounds(bounds); // Ensure all stops are visible
    
            // Force polyline to update
            setPolylineVisible(false);
            setTimeout(() => {
                setPolylineVisible(true);
            }, 50);
        }
    }, [routeData, map]);   
    
    const handleDeleteTripBooking = async(row) => {
        const payload = {
            token: token,
            booking_id: row.booking_id,
            // is_active: 0
        };

        try {
            const url = operationsUrl + '/shuttle/cancel_shuttle_booking';
            const response = await makePostRequestToUrl(url,payload);
            console.log('response=', response)
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                fetchBookingData();
            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
            else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            setMessage(error);
        }
    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    return(
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Trip Booking Details</Typography>

            <Modal open={openRouteModal} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Booking ID : {bookingId}
                    </Typography>
                    <hr/>
                    <Grid2 id="modal-modal-description" sx={{ mt: 2 }}>
                        <Grid2 item container>
                            <Grid2 item sx={{display:'flex'}}>
                                <img src={pickupMarker} alt="Pickup Point" />
                                <Typography sx={{marginLeft:'4px'}}>Pickup Point</Typography>
                            </Grid2>
                            <Grid2 item sx={{display:'flex', marginLeft:'4%'}}>
                                <img src={dropMarker} alt="Drop Point" />
                                <Typography sx={{marginLeft:'4px'}}>Drop Point</Typography>
                            </Grid2>
                        </Grid2>

                        <Grid2 className='mainBox' sx={{marginTop:'2%'}}>
                            {isLoaded ? (
                                <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={6} onLoad={onLoad} onUnmount={onUnmount}>
                                    {routeData && polylineVisible && routeData.map((stop, index) => {
                                        // Determine which marker to use based on the conditions
                                        let markerIcon;
                                        if (stop.is_pickup_stop) {
                                            markerIcon = {
                                            url: pickupMarker,
                                            scaledSize: new window.google.maps.Size(30, 30),
                                            labelOrigin: new window.google.maps.Point(20, 14)
                                            };
                                        } else if (stop.is_drop_stop) {
                                            markerIcon = {
                                            url: dropMarker,  // Assuming you have a dropMarker image
                                            scaledSize: new window.google.maps.Size(30, 30),
                                            labelOrigin: new window.google.maps.Point(20, 14)
                                            };
                                        } 
                                        else {
                                            markerIcon = {
                                            url: routeMarker,
                                            scaledSize: new window.google.maps.Size(20, 20),
                                            labelOrigin: new window.google.maps.Point(20, 14)
                                            };
                                        }

                                        return (
                                            <Marker 
                                            key={index}
                                            position={{ lat: Number(stop.latitude), lng: Number(stop.longitude) }}
                                            // title={stop.route_id}
                                            icon={markerIcon}
                                            />
                                        );
                                    })}

                                    {routeData && polylineVisible && routeData.length > 1 && (
                                        <Polyline
                                            path={routeData.map((stop) => ({
                                            lat: Number(stop.latitude),
                                            lng: Number(stop.longitude),
                                            }))}
                                            options={{
                                            strokeColor: "#0065FF",
                                            strokeOpacity: 1.0,
                                            strokeWeight: 4,
                                            }}
                                        />
                                    )}

                                </GoogleMap>
                                
                            ): (<></>)}
                        </Grid2>
                    </Grid2>
                </Box>
            </Modal>

            <TableContainer className="table-container" style={{maxHeight:'80vh'}}>
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            {/* <TableCell align="center" className="table-header" style={{ width: '15%' }}>Booking ID</TableCell> */}
                            <TableCell align="center" className="table-header">
                                <TableSortLabel className='table-header' active={orderBy === 'booking_id'} direction={orderBy === 'booking_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('booking_id')} sx={{
                                        '& .MuiTableSortLabel-icon': {
                                            color: '#0065FF !important', // Change the arrow color
                                        },
                                    }}>
                                    Booking ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <Typography sx={{padding:'12px'}}>User</Typography>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel className='table-header' active={orderBy === 'trip_id'} direction={orderBy === 'trip_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('trip_id')} sx={{
                                        '& .MuiTableSortLabel-icon': {
                                            color: '#0065FF !important', // Change the arrow color
                                        },
                                    }}>
                                    Trip ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <Typography sx={{padding:'12px'}}>Route</Typography>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <Typography sx={{padding:'12px'}}>Date</Typography>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <Typography sx={{padding:'12px'}}>Time</Typography>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <Typography sx={{padding:'12px'}}>Seats</Typography>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <Typography sx={{padding:'12px'}}>Pickup Point</Typography>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <Typography sx={{padding:'12px'}}>Drop Point</Typography>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <Typography sx={{padding:'12px'}}>Amount</Typography>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <Typography sx={{padding:'12px'}}>Payments</Typography>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <Typography sx={{padding:'12px'}}>Status</Typography>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <Typography sx={{padding:'12px'}}>Action</Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                    {paginatedData.length === 0 ? (
                        <TableRow>
                            <TableCell colSpan={13} align="center">
                                <Typography variant="body1">No data found</Typography>
                            </TableCell>
                        </TableRow>
                    ) : (
                        paginatedData.map((row) => (
                            <TableRow key={row.id}>
                                <TableCell align="center">
                                    <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.booking_id}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Grid2 container sx={{ width: "auto", minWidth: "180px" }}>
                                        <Grid2>
                                            <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt={row.user_name} src={row.user_image} />
                                        </Grid2>
                                        <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                                            <Grid2><Typography>{row.user_name}</Typography></Grid2>
                                            <Grid2><Typography sx={{ color: "#83888E", fontSize: "12px" }}>{clientdataShown == '0' ? row.phone_number : (() => {
                                        if (!row.phone_number) return '****';
                                        const phone = row.phone_number;
                                        // Remove any non-digit characters for processing
                                        const cleanPhone = phone.replace(/\D/g, '');
                                        if (cleanPhone.length <= 4) return '****';
                                        const firstTwo = cleanPhone.substring(0, 2);
                                        const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                                        const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                                        return "+" + firstTwo + maskedMiddle + lastTwo;
                                    })()}</Typography></Grid2>
                                        </Grid2>
                                    </Grid2>
                                </TableCell>
                                <TableCell align="center">
                                    <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.trip_id}</Typography>
                                </TableCell>
                                <TableCell align="center">
                                    <Typography
                                        sx={{
                                            width: 'auto',
                                            minWidth: '100px',
                                            color: '#0065FF',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => viewRoute(row)}
                                    >
                                        View Route
                                    </Typography>
                                </TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.trip_date.split('T')[0]}</Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.time}</Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.ticket_count}</Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.pickup_address}</Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.drop_address}</Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{((row.fare) * row.ticket_count)}</Typography></TableCell>
                                <TableCell align="center">
                                    <Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                        {row.payment_status === 0 ? 'PENDING' : row.payment_status === 1 ? 'PAID' : 'FAILED'}
                                    </Typography>
                                </TableCell>
                                <TableCell align="center">
                                    <Typography
                                        sx={{
                                            width: 'auto',
                                            minWidth: '120px',
                                            color:
                                                row.status === 1 ? '#6e706f' :
                                                row.status === 2 ? '#D14545' :
                                                row.status === 3 ? '#FFA500' : // Orange for PICKED_UP
                                                row.status === 6 ? '#0DBA78' : // SlateBlue for ENDED
                                                row.status === 7 ? '#ab434b' :
                                                '#000',
                                            fontWeight: '500',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                    
                                        {{
                                            1: 'Booked',
                                            2: 'Cancelled',
                                            3: 'Onboarded',
                                            6: 'Ended',
                                            7: 'Missed'
                                        }[row.status] || 'Unknown'}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    {row.status === 1 && (
                                        <Button
                                            variant="contained"
                                            onClick={() => handleDeleteTripBooking(row)}
                                            sx={{
                                                backgroundColor: '#FFF5F5',
                                                color: '#D14545',
                                                border: '1px solid #D14545',
                                                textTransform: 'none',
                                                borderRadius: '8px',
                                                minWidth: '40px',
                                                boxShadow: 'none',
                                                width: "140px",
                                                margin: '2px',
                                                '&:hover': {
                                                    backgroundColor: '#D14545',
                                                    color: 'white'
                                                },
                                                '&:active': {
                                                    backgroundColor: '#D14545',
                                                    color: 'white'
                                                }
                                            }}
                                        >
                                            <Typography sx={{ marginRight: '6%' }}>Cancel</Typography>
                                        </Button>
                                    )}
                                </TableCell>
                            </TableRow>
                        ))
                    )}

                    </TableBody>
                </Table>

                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            filteredRows.length
                        )} of ${filteredRows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                    <button
                        onClick={() => handleChangePage(null, page - 1)}
                        disabled={page === 0}
                        className="pagination-arrow"
                    >
                        <img src={prevIcon} alt="Previous" />
                    </button>
                    
                        <div className="pagination-numbers">
                            {/* {[...Array(Math.ceil(filteredRows.length / rowsPerPage))].map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${
                                        page === index ? 'active' : ''
                                    }`}
                                >
                                    {index + 1}
                                </button>
                            ))} */}
                            {page > 1 && (
                                <>
                                    <button onClick={() => handleChangePage(null, 0)} className="pagination-number">
                                        1
                                    </button>
                                    <span className="pagination-dots">...</span>
                                </>
                            )}
                            {[...Array(Math.ceil(filteredRows.length / rowsPerPage))]
                                .map((_, index) => index)
                                .filter((index) => index >= page - 1 && index <= page + 1) // Show only previous, current, and next page
                                .map((index) => (
                                    <button
                                        key={index}
                                        onClick={() => handleChangePage(null, index)}
                                        className={`pagination-number ${page === index ? 'active' : ''}`}
                                    >
                                        {index + 1}
                                    </button>
                            ))}

                            {page < Math.ceil(filteredRows.length / rowsPerPage) - 2 && (
                                <>
                                    <span className="pagination-dots">...</span>
                                    <button
                                        onClick={() => handleChangePage(null, Math.ceil(filteredRows.length / rowsPerPage) - 1)}
                                        className="pagination-number"
                                    >
                                        {Math.ceil(filteredRows.length / rowsPerPage)}
                                    </button>
                                </>
                            )}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(filteredRows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>

        </div>
    )
}

export default ShuttleBooking;